import styled from 'styled-components'
import Heading from '../../../stories/atoms/Heading/Heading'
import ButtonAsync from '../../../stories/atoms/ButtonAsync/ButtonAsync'
import breakpoints from '../../../stories/theme/breakpoints'
import Fonts from '../../../stories/theme/fonts'
import colors from '../../../stories/theme/colors'

const IMAGE_SIZE = 363;

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  align-self: flex-start;
  justify-content: space-around;
  flex-wrap: wrap;
  transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
  width: 100%;

  * {
    text-decoration: none !important;
    transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
  }

  :hover {
    text-decoration: none !important;
  }

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }
`

export const Image = styled.img`
  object-fit: contain;
  aspect-ratio: 1 / 1;
  max-width: ${IMAGE_SIZE}px;
  flex: 50%;
  width: 50%;
  margin-right: 24px;

  @media (max-width: ${breakpoints.laptop}) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 16px;
  }
`

export const BuyProductButton = styled(ButtonAsync)`
  min-width: fit-content;

  @media (max-width: ${breakpoints.tablet}) {
    margin-top: 8px;
    margin-right: 0;
  }
`

export const Price = styled(Heading).attrs({ size: 'small' })`
  position: static;

  @media (max-width: ${breakpoints.tablet}) {
    align-self: flex-end;
  }

  @media (max-width: ${breakpoints.mobile}) {
    bottom: 32px;
    font-size: ${Fonts.fontSizes.p18};
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 50%;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);
  min-height: ${IMAGE_SIZE}px;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    flex: 100%;
  }
`

export const ListItem = styled.li`
  line-height: 28px;
  font-size: ${Fonts.fontSizes.p16};
  font-family: ${Fonts.fontFamilies.Inter};
  display: flex;

  > svg {
    min-width: 18px;
    margin-top: 6px;
    margin-right: 12px;
  }
`

export const ProductDescription = styled.div`
  @media (max-width: ${breakpoints.tablet}) {
    margin-bottom: 16px;
  }
`

export const DescriptionList = styled.ul`
  margin: 12px 0 0 0;
  padding: 0;
  list-style: none;
`

export const Title = styled(Heading)`
  margin: 0px;
  font-size: 28px;
  margin-bottom: 16px;
  line-height: 32px;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 24px;
  }
`

export const MobileTitle = styled(Heading)`
  font-size: 18px;
`

export const MobileHeading = styled.div<{ icon: string }>`
  background-image: url('data:image/svg+xml;base64,${props => props.icon}');

  background-repeat: no-repeat;
  background-position-x: right;
  background-size: 40px;
  background-blend-mode: screen;
  background-origin: unset;
  background-position-y: top;
  background-origin: border-box;
  padding-right: 60px;
  padding-bottom: 32px;

  @media (min-width: ${breakpoints.tablet}) {
    display: none;
  }
`

export const DesktopHeading = styled.div<{ icon: string }>`
  flex: 100%;
  background-image: url('data:image/svg+xml;base64,${props => props.icon}');
  background-repeat: no-repeat;
  background-position-x: right;
  background-size: 200px;
  background-blend-mode: screen;
  background-origin: unset;
  background-position-y: top;
  padding-right: 200px;
  padding-bottom: 48px;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`

export const ContainerDivider = styled.hr`
  margin: 48px 0;
  border-top: 1px solid ${colors.Primary.Grey};

  @media (max-width: ${breakpoints.tablet}) {
    margin: 32px 0;
  }
`

export const CardDivider = styled.hr`
  margin: 16px 0;
  border-top: 1px solid ${colors.Primary.GreyLight};
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Footer = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 2fr 1fr;

  @media (max-width: ${breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`
